import { MindmapData } from '../../types';

export const mindmaps: MindmapData[] = [
  {
    id: 'mm-grundsaetze',
    title: 'Grundsätze der EU',
    icon: '📋',
    cards: [
      {
        title: '🕊️ Gemeinsame Werte & Ziele',
        color: 'green',
        speech: 'Grundsatz Nummer 1: Gemeinsame Werte und Ziele. Die EU-Länder teilen wichtige Werte wie Freiheit, Demokratie und die Einhaltung der Menschenrechte. Das bedeutet, dass die Menschen in der EU frei leben und ihre Meinung offen sagen dürfen. Niemand darf wegen seiner Meinung bestraft werden. Ein großes Ziel der EU ist die Sicherung von Frieden, das Schaffen von Wohlstand und zufriedene Bürger.',
        items: [
          'Freiheit – Alle Menschen dürfen frei leben',
          'Demokratie – Das Volk bestimmt mit',
          'Menschenrechte – Jeder darf seine Meinung sagen',
          'Ziele: Frieden, Wohlstand, Wirtschaftswachstum',
        ],
      },
      {
        title: '💶 Wirtschaftliche Zusammenarbeit',
        color: 'blue',
        speech: 'Grundsatz Nummer 2: Wirtschaftliche Zusammenarbeit. Die Länder der EU arbeiten wirtschaftlich eng zusammen. Das bedeutet, dass Waren, Geld und Personen problemlos über Landesgrenzen bewegt werden können. Besonders wichtig: Es gibt keine Zölle zwischen EU-Ländern. Das nennt man den gemeinsamen Markt.',
        items: [
          'Enge Zusammenarbeit beim Handel',
          'Waren, Geld, Personen bewegen sich frei',
          'Keine Zölle zwischen EU-Ländern',
          'Gemeinsamer Markt stärkt alle',
        ],
      },
      {
        title: '⚖️ Politische Zusammenarbeit',
        color: 'purple',
        speech: 'Grundsatz Nummer 3: Politische Zusammenarbeit. Die EU-Länder arbeiten auch politisch zusammen. Sie machen gemeinsame Regeln und Gesetze, die für alle Mitgliedsstaaten gelten. Diese Regeln werden vom Europäischen Parlament festgelegt. Der große Vorteil: Zusammen sind die Länder stärker als allein.',
        items: [
          'Gemeinsame Regeln & Gesetze für alle',
          'EU-Parlament legt Gesetze fest',
          'Alle Länder müssen sich daran halten',
          'Zusammen stärker als allein',
        ],
      },
      {
        title: '🤝 Zusammenhalt in Krisen',
        color: 'orange',
        speech: 'Grundsatz Nummer 4: Zusammenhalt in Krisenzeiten. Besonders in schwierigen Zeiten halten die EU-Länder zusammen. Bei Naturkatastrophen wie Überschwemmungen oder Erdbeben unterstützen sich die Länder gegenseitig mit Hilfslieferungen und Rettungskräften. Niemand soll in einer Krise allein sein.',
        items: [
          'Naturkatastrophen – gemeinsam helfen',
          'Krieg – füreinander einstehen',
          'Gegenseitige Unterstützung',
          'Niemand ist in einer Krise allein',
        ],
      },
    ],
  },
  {
    id: 'mm-vorteile-nachteile',
    title: 'Vorteile & Nachteile',
    icon: '👍👎',
    cards: [
      {
        title: '🛫 Freies Reisen & Arbeiten',
        color: 'green',
        speech: 'Vorteil Nummer 1: Freies Reisen und Arbeiten. Als EU-Bürgerin kannst du ohne Visum in andere EU-Länder reisen. Du kannst in jedem EU-Land leben und arbeiten, ohne eine spezielle Erlaubnis zu brauchen. Es gibt keine Grenzkontrollen zwischen den meisten EU-Ländern.',
        items: [
          'Ohne Visum in EU-Ländern reisen',
          'In jedem EU-Land leben und arbeiten',
          'Keine Grenzkontrollen nötig',
        ],
      },
      {
        title: '💶 Gemeinsame Währung',
        color: 'green',
        speech: 'Vorteil Nummer 2: Gemeinsame Währung. Der Euro ist die gemeinsame Währung in vielen EU-Ländern. Wenn du zum Beispiel nach Deutschland, Italien oder Spanien fährst, musst du kein Geld wechseln. Aktuell nutzen 20 EU-Länder den Euro.',
        items: [
          'Der Euro erleichtert Handel und Reisen',
          'Kein Geld wechseln nötig',
          'Stabile Währung schafft Vertrauen',
          '20 EU-Länder nutzen den Euro',
        ],
      },
      {
        title: '🕊️ Frieden & Stabilität',
        color: 'green',
        speech: 'Vorteil Nummer 3: Frieden und Stabilität. Das ist vielleicht der wichtigste Vorteil überhaupt. Seit Jahrzehnten gibt es in der EU keinen Krieg mehr zwischen den Mitgliedsländern. Die enge Zusammenarbeit hat dazu beigetragen, dass Frieden herrscht.',
        items: [
          'Seit Jahrzehnten kein Krieg in der EU',
          'Zusammenarbeit fördert Frieden',
          'Gemeinsame politische Strukturen',
        ],
      },
      {
        title: '🏪 Binnenmarkt',
        color: 'green',
        speech: 'Vorteil Nummer 4: Der Binnenmarkt. Der EU-Binnenmarkt funktioniert wie ein riesiges Land ohne Grenzen. Waren, Dienstleistungen, Geld und Menschen können sich frei bewegen. Es gibt keine Zölle zwischen EU-Ländern.',
        items: [
          'Wie ein großes Land ohne Grenzen',
          'Waren, Dienstleistungen, Geld frei bewegen',
          'Keine Zölle zwischen EU-Ländern',
          'In jedem EU-Land arbeiten & studieren',
        ],
      },
      {
        title: '⚖️ Menschenrechte',
        color: 'green',
        speech: 'Vorteil Nummer 5: Menschenrechte. Die EU schützt Grundfreiheiten in allen Mitgliedsländern. Es gelten hohe Standards für Demokratie und Rechtsstaatlichkeit. Die Menschenwürde wird in der gesamten EU geschützt.',
        items: [
          'EU schützt Grundfreiheiten',
          'Hohe Standards für Demokratie',
          'Rechtsstaatlichkeit in allen Ländern',
          'Schutz der Menschenwürde',
        ],
      },
      {
        title: '🏛️ Bürokratie',
        color: 'red',
        speech: 'Nachteil Nummer 1: Bürokratie. Die EU-Strukturen sind sehr komplex. Entscheidungen dauern oft sehr lange, weil viele verschiedene Ebenen mitreden müssen. Manchmal dauert es Jahre, bis eine neue Regelung beschlossen wird.',
        items: [
          'EU-Strukturen sind komplex',
          'Entscheidungen dauern sehr lange',
          'Viele Ebenen führen zu Verzögerungen',
          'Umsetzung von Maßnahmen wird erschwert',
        ],
      },
      {
        title: '🏳️ Souveränitätsverlust',
        color: 'red',
        speech: 'Nachteil Nummer 2: Souveränitätsverlust. Wenn ein Land der EU beitritt, muss es einen Teil seiner Entscheidungsmacht abgeben. EU-Gesetze gelten über den nationalen Gesetzen. Ein berühmtes Beispiel ist der Brexit 2020.',
        items: [
          'Länder geben Entscheidungsmacht ab',
          'EU-Gesetze gelten über nationalen',
          'Bürger fühlen sich übergangen',
          'Beispiel: Brexit 2020',
        ],
      },
      {
        title: '💰 Ungleiche Wirtschaft',
        color: 'red',
        speech: 'Nachteil Nummer 3: Ungleiche wirtschaftliche Entwicklung. Trotz aller Bemühungen gibt es innerhalb der EU große Unterschiede zwischen reichen und ärmeren Ländern. Länder wie Deutschland oder Österreich sind wirtschaftlich sehr stark, während andere Länder noch aufholen müssen.',
        items: [
          'Große Unterschiede reich vs. arm',
          'Manche Länder profitieren mehr',
          'Ungleicher Wohlstand & Einkommen',
          'Führt zu Spannungen',
        ],
      },
    ],
  },
  {
    id: 'mm-mitglieder',
    title: 'EU Mitgliedsstaaten',
    icon: '🗺️',
    cards: [
      {
        title: '🌍 Mitteleuropa (8)',
        color: 'green',
        speech: 'Mitteleuropa: 8 Länder. Das ist unsere Region! Österreich liegt hier, zusammen mit Deutschland, Polen, Tschechien, Slowakei, Ungarn, Slowenien und Kroatien. Deutschland ist das bevölkerungsreichste EU-Land mit der stärksten Wirtschaft.',
        items: [
          '🇦🇹 Österreich – Unser Land!',
          '🇩🇪 Deutschland',
          '🇵🇱 Polen · 🇨🇿 Tschechien',
          '🇸🇰 Slowakei · 🇭🇺 Ungarn',
          '🇸🇮 Slowenien · 🇭🇷 Kroatien',
        ],
      },
      {
        title: '🌊 Westeuropa (5)',
        color: 'blue',
        speech: 'Westeuropa: 5 Länder. Frankreich, Belgien, Niederlande, Luxemburg und Irland. Besonders wichtig: Belgien, Niederlande und Luxemburg sind die Benelux-Staaten und gehören zu den Gründerstaaten der EU. In Brüssel hat die EU ihren Sitz.',
        items: [
          '🇫🇷 Frankreich',
          '🇧🇪 Belgien (EU-Sitz!)',
          '🇳🇱 Niederlande',
          '🇱🇺 Luxemburg (Gründerstaat)',
          '🇮🇪 Irland',
        ],
      },
      {
        title: '❄️ Nordeuropa (3)',
        color: 'teal',
        speech: 'Nordeuropa: 3 Länder. Schweden, Finnland und Dänemark. Diese Länder liegen im Norden Europas und sind bekannt für ihre kalten Winter und hohe Lebensqualität.',
        items: [
          '🇸🇪 Schweden',
          '🇫🇮 Finnland',
          '🇩🇰 Dänemark',
        ],
      },
      {
        title: '☀️ Südeuropa (6)',
        color: 'orange',
        speech: 'Südeuropa: 6 Länder. Italien, Spanien, Portugal, Griechenland, Malta und Zypern. Italien ist besonders wichtig als eines der Gründerländer der EU. Malta und Zypern sind die kleinsten EU-Mitglieder.',
        items: [
          '🇮🇹 Italien (Gründerland!)',
          '🇪🇸 Spanien · 🇵🇹 Portugal',
          '🇬🇷 Griechenland',
          '🇲🇹 Malta · 🇨🇾 Zypern',
        ],
      },
      {
        title: '🌾 Osteuropa / Baltikum (3)',
        color: 'purple',
        speech: 'Osteuropa beziehungsweise die Baltischen Staaten: 3 Länder. Estland, Lettland und Litauen. Diese drei Länder liegen an der Ostsee und sind 2004 der EU beigetreten.',
        items: [
          '🇪🇪 Estland',
          '🇱🇻 Lettland',
          '🇱🇹 Litauen',
        ],
      },
      {
        title: '🏔️ Südosteuropa (2)',
        color: 'red',
        speech: 'Südosteuropa: 2 Länder. Rumänien und Bulgarien. Beide Länder sind 2007 der EU beigetreten und liegen am Schwarzen Meer.',
        items: [
          '🇷🇴 Rumänien',
          '🇧🇬 Bulgarien',
        ],
      },
    ],
  },
];
